export default __webpack_public_path__ + "static/media/citysunset.49bfeb60.png";